const icon = new URL('../../icons/sphere.png', import.meta.url).href

export default {
  type: 'sphere',
  description: '3D sphere',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'sphere',
    cx: 100,
    cy: 100,
    rx: 50,
    ry: 50,
    rz: 50,
    zPos: 50,
    fillStyle: '#aaaaaa',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1
  }
}
